const Introduction = () => {
  const data = [
    {
      id: 1,
      title: "K-CDH 네이버 카페",
      src: "/assets/img/mp-1.png",
      href: "https://cafe.naver.com/diaphragmatichernia",
    },
    {
      id: 2,
      title: "소아암·희귀질환지원사업단",
      src: "/assets/img/mp-2.png",
      href: "https://www.ccrdp.org/front/",
    },
    {
      id: 3,
      title: "대한신생아학회",
      src: "/assets/img/mp-3.png",
      href: "https://www.neonatology.or.kr/",
    },
    {
      id: 4,
      title: "한국신생아네트워크",
      src: "/assets/img/mp-4.png",
      href: "https://www.knn.or.kr/main",
    },
    {
      id: 5,
      title: "희귀질환 헬프라인",
      src: "/assets/img/mp-5.png",
      href: "https://helpline.kdca.go.kr/cdchelp/",
    },
  ];

  return (
    <section className="common mpage2">
      <div className="width">
        <div className="title">
          <h2>
            <b>K-CDH</b> Partner
          </h2>
          <span>K-CDH 파트너를 소개합니다.</span>
        </div>

        <div className="box_wrap">
          {data.map((item) => (
            <a href={item.href} target="_blank" rel="noreferrer" key={item.id}>
              <img src={item.src} alt="" />
              <span>{item.title || "-"}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Introduction;
